export default __webpack_public_path__ + "static/media/tutorials-icon.96aef96b.svg";